module.exports = __webpack_public_path__ + "fonts/iconfont.61df2048.eot";